import { PromoCodeType } from './PromoCodeType';
import { ByType } from './ByType';
import Localization from './Localization';
import Assets from './Assets';
import PiggyReward from './PiggyReward';

export default class PromoCode {
	_id: any;
	active: boolean;
	availability?: ByType<boolean>;
	amount: number;
	cities?: string[];
	code: string;
	countries?: string[];
	customerGroup?: string;
	from?: string;
	giftCards?: string[];
	usedGiftCards?: string[];
	mov?: string | number;
	isMultipleApplicable: boolean;
	states?: string[];
	to?: string;
	label?: string | PromoCode;
	name: string;
	type: PromoCodeType;
	value?: any;
	venues: string[];
	description?: Localization;
	image?: Assets;
	availableForCustomerToUse?: boolean;
	piggyReward: PiggyReward;
	redeemableAtCheckoutOnly?: boolean;
	isMaster?: boolean;
}
